export default __webpack_public_path__ + "static/media/start-chat.231510ac.svg";